import {
    ROUTE_PATH_ADMIN_BREACH_INCIDENT_REQUEST,
    ROUTE_PATH_ADMIN_DATA_SUBJECT_REQUEST,
} from 'src/modules/data-protection/constants';

export const DATA_SUBJECT_REQUEST = 'data_subject_request';
export const DATA_BREACH_INCIDENT = 'data_breach_incident';

export const items = [
    {
        code: DATA_SUBJECT_REQUEST,
        buttonKey: 'Request',
        addKey: 'Add to Request',
        titleKey: 'Data Subject Request',
        pillTitle: 'Request ID',
        pillClass: 'mailbox-message-row__pill--request',
        labelDotClass: 'mailbox-sidebar__dot--request',
        successKey: 'Data Subject Request created from this email.',
        createdTitleKey: 'Request created',
        createdBodyKey: 'Your email was converted into a request.',
        viewKey: 'View request',
        caseDetailPath: (id) => (
            `${ROUTE_PATH_ADMIN_DATA_SUBJECT_REQUEST}/details/${encodeURIComponent(id)}`
        ),
    },
    {
        code: DATA_BREACH_INCIDENT,
        buttonKey: 'Incident',
        addKey: 'Add to Incident',
        titleKey: 'Security Incident',
        pillTitle: 'Incident ID',
        pillClass: 'mailbox-message-row__pill--incident',
        labelDotClass: 'mailbox-sidebar__dot--incident',
        successKey: 'Security Incident created from this email.',
        createdTitleKey: 'Incident created',
        createdBodyKey: 'Your email was converted into an incident.',
        viewKey: 'View incident',
        caseDetailPath: (id) => (
            `${ROUTE_PATH_ADMIN_BREACH_INCIDENT_REQUEST}/details/${encodeURIComponent(id)}`
        ),
    },
];

export const sidebarLabelCodes = [
    DATA_BREACH_INCIDENT,
    DATA_SUBJECT_REQUEST,
];
